import { render, staticRenderFns } from "./Browser.vue?vue&type=template&id=f1dc9706&scoped=true&"
import script from "./Browser.vue?vue&type=script&lang=ts&"
export * from "./Browser.vue?vue&type=script&lang=ts&"
import style0 from "./Browser.vue?vue&type=style&index=0&id=f1dc9706&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1dc9706",
  null
  
)

export default component.exports